// extracted by mini-css-extract-plugin
module.exports = {"lightTheme":"button-module--light-theme--28Vx7","buttonStyle":"button-module--buttonStyle--1HV5R","arrow":"button-module--arrow--1VcIg"};